import { render, staticRenderFns } from "./AppointmentSection.vue?vue&type=template&id=71c05fb7&scoped=true"
import script from "./AppointmentSection.vue?vue&type=script&lang=js"
export * from "./AppointmentSection.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSection.vue?vue&type=style&index=0&id=71c05fb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c05fb7",
  null
  
)

export default component.exports